export const validateUrlProtocol = (url) => {
  try {
    const parsed = new URL(url);
    return ['https:', 'http:', 'mailto:', 'tel:'].includes(parsed.protocol);
  } catch (err) {
    return false;
  }
};
